module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10049.e2f2a58b.jpg";